import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Space, Typography } from 'antd';

const { Search } = Input;

export default function TableSearchBar({
    disabled,
    handleOnFocus,
    placeholder,
    searchAction,
    searchTerm,
    width,
    errorMessage
}: {
    disabled?: boolean;
    handleOnFocus?: () => void;
    placeholder: string;
    searchAction: (value: string) => void;
    searchTerm: string;
    width?: string | number;
    errorMessage?: string;
}) {
    return (
        <Space direction="vertical" style={{ maxWidth: 500, width: width || 300 }}>
            <Search
                className="full-width"
                placeholder={placeholder}
                onSearch={(v) => searchAction(v)}
                onChange={(e) => searchAction(e.target.value)}
                disabled={disabled}
                onFocus={() => handleOnFocus && handleOnFocus()}
                onKeyDown={(e) => {
                    e.key === 'Enter' && e.preventDefault();
                }}
                onClick={(e) => e.stopPropagation()}
                enterButton={
                    <Button
                        disabled={disabled}
                        onClick={(e) => e.stopPropagation()}
                        style={{ padding: '4px 8px' }}
                        {...(errorMessage ? { danger: true } : undefined)}
                    >
                        <SearchOutlined />
                    </Button>
                }
                value={searchTerm}
                status={errorMessage ? 'error' : undefined}
            />
            <Typography.Text type="danger">{errorMessage}</Typography.Text>
        </Space>
    );
}
